/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { get } from 'lodash';
import axios from 'axios';
import { ArrowBack } from '@material-ui/icons';
import CTAButton from '../Shared/CTAButton';
import ErrorModal from '../Shared/ErrorModal';
import { API_ROOT, ACCEPT_LANGUAGE_HEADER } from '../../apiConfig';
import { defaultErrorMessage } from '../../constants';
import { loadClient } from '../../Actions';
import yogaGif from '../../Assets/Images/yoga.gif';
import './styles.scss';
import { pauseSoothePass, resumeSoothePass } from '../Shared/Helpers';
import moment from 'moment';
import SuccessModal from '../Shared/SuccessModal';

class PauseMembership extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: '',
      showErrorModal: false,
      showSuccessModal: false,
      width: window.innerWidth,
    };
  }
  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  handlePauseMembership = () => {
    const clientId = get(this.props, 'client.user_id', '');
    const {
      soothe_pass_subscription_id,
      subscription_tier_id,
      city_id,
      credit_card_id,
    } = get(this.props, 'client.soothe_pass', {});
    this.setState({ isLoading: true });
    pauseSoothePass(clientId, soothe_pass_subscription_id, {
      subscription_tier_id, city_id, credit_card_id
    }, (resp) => {
      const { result, subscription } = resp.data;
      if (result) {
        this.setState({
          isPaused: true,
          isLoading: false,
          pause_end_date: subscription?.pause_end_date,
          pause_start_date: subscription?.pause_start_date,
        });
      } else {
        const message = get(resp, 'data.errors.0.message', defaultErrorMessage);
        this.setState({
          showErrorModal: true,
          error: message,
          isLoading: false,
        });

      }
    }, (err) => {
      const message = get(err, 'response.data.errors.0.message', defaultErrorMessage);
      this.setState({
        showErrorModal: true,
        error: message,
        isLoading: false,
      });
    });
  };

  handleResumeMembership = async () => {
    const { soothe_pass_subscription_id, credit_card_id } = get(this.props, 'client.soothe_pass', {});
    const user_id = get(this.props, 'client.user_id', '');
    this.setState({ isLoading: true });
    resumeSoothePass(user_id, soothe_pass_subscription_id, credit_card_id, (resp) => {
      const { result } = resp.data;
      if (result) {
        this.setState({
          isPaused: false,
          isLoading: false,
          resumeDate: null,
          showSuccessModal: true,
        });
      } else {
        const message = get(resp, 'data.errors[0].message', defaultErrorMessage);
        this.setState({
          showErrorModal: true,
          error: message,
          isLoading: false,
        });
      }
    }, (err) => {
      const message = get(err, 'response.data.errors[0].message', defaultErrorMessage);
      this.setState({
        showErrorModal: true,
        error: message,
        isLoading: false,
      });
    });
  };

  renderPausedState() {
    const { resumeDate, isLoading } = this.state;
    const subscription_next_charge_date_only = get(this.props, 'client.soothe_pass.subscription_next_charge_date_only', '');

    return (
      <div className="pause-membership-container-redesign contentPrimary">
        <div className="back-button" onClick={this.props.handleBack} role="button" tabIndex={0} onKeyDown={this.props.handleBack}>
          <ArrowBack className='w-h-20-imp BlackBlueish' />
        </div>
        <div className='size-24-32 font-weight-bold mb-16'>Membership Paused</div>
        <div className='size-16-24 mb-16'>Your SoothePass membership is currently paused and will automatically resume on {subscription_next_charge_date_only}.</div>
        {/* <CTAButton
          text={isLoading ? 'Resuming...' : 'Resume Membership Now'}
          action={this.handleResumeMembership}
          disabled={isLoading}
          additionalWrapperClass="br-top-none-imp"
        /> */}
        <button 
          type='button' 
          onClick={this.handleResumeMembership}
          disabled={isLoading}
          style={{
            width: '343px',
            padding: '16px 20px',
            borderRadius: '30px',
            border: 'none',
            backgroundColor: isLoading ? '#CBCBCB' : '#F58266',
            color: '#FFFFFF',
            fontFamily: 'Poppins',
            fontWeight: '500',
            fontSize: '18px',
            lineHeight: '1.3333333333333333em',
            textAlign: 'center',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            marginTop: '16px'
          }}
        >
          {isLoading ? 'Resuming...' : 'Resume Membership Now'}
        </button>

      </div>
    );
  }
  renderPausePendingState() {
    const { pause_end_date, pause_start_date } = this.state;
    const formattedPauseStartDate = pause_start_date ? moment(pause_start_date, "YYYY-MM-DD").format('MMM D, YYYY') : '';
    const formattedPauseEndDate = pause_end_date ? moment(pause_end_date, "YYYY-MM-DD").format('MMM D, YYYY') : '';

    return (
      <div className='contentPrimary'>
        <div className='size-24-32 font-weight-bold mb-16'>Your membership will be paused on {formattedPauseStartDate}</div>
        <div className='size-16-24 mb-16'>You can still access your member benefits while paused.<br />
          Your next billing will resume on {formattedPauseEndDate}.</div>
        <div className='mb-24'>
          <button
            onClick={() => this.props.openFAQ(true)}
            type='button'
            style={{
              padding: '16px 20px',
              borderRadius: '30px',
              border: 'none',
              backgroundColor: 'transparent',
              color: '#586B94',
              fontFamily: 'Poppins',
              fontWeight: '500',
              fontSize: '18px',
              lineHeight: '1.3333333333333333em',
              cursor: 'pointer'
            }}
          >
            Explore FAQ
          </button>
        </div>
        <button 
          type='button' 
          onClick={() => this.props.handleBack(true)}
          style={{
            width: '343px',
            padding: '16px 20px',
            borderRadius: '30px',
            border: 'none',
            backgroundColor: '#F58266',
            color: '#FFFFFF',
            fontFamily: 'Poppins',
            fontWeight: '500',
            fontSize: '18px',
            lineHeight: '1.3333333333333333em',
            textAlign: 'center',
            cursor: 'pointer'
          }}
        >
          Done
        </button>
      </div>
    );
  }

  renderPauseForm() {
    const { isLoading, width } = this.state;
    const { comingFromCancel } = this.props;

    return (
      <div className="pause-membership-container-redesign contentPrimary">
        <div className="back-button" onClick={this.props.handleBack} role="button" tabIndex={0} onKeyDown={this.props.handleBack}>
          <ArrowBack className='w-h-20-imp BlackBlueish' />
        </div>
        <div className="size-24-32 font-weight-bold contentPrimary mb-24">{
          comingFromCancel ? "Keep your points, pause instead." : "Busy schedule? Pause your membership."}</div>
        <div className="d-flex-only justify-content-spaced align-items-center mb-24">
          <div className="illustration">
            <img src={yogaGif} alt="Person doing yoga" />
          </div>
          {comingFromCancel ?
            <div className="contentPrimary size-16-24">
              To ensure you're getting the best prices, pause your membership instead. This gives you time to continue to use your existing points without the membership fee.
            </div>
            : <div className="contentPrimary size-16-24">
              While paused, you:
              <ul>
                <li>Will skip your next billing cycle</li>
                <li>Will not have access to exclusive membership pricing</li>
                <li>Can still redeem any points you currently have</li>
                <li>Can resume membership anytime</li>
              </ul>
            </div>}
        </div>
        <div style={{
          borderTop: '1px solid #E2E2E2',
          padding: '16px 0',
          alignSelf: 'stretch'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '0 16px',
            alignSelf: 'stretch',
            flexDirection: width >= 800 ? 'row' : 'column',
            alignItems: 'center'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              padding: '0 16px'
            }}>
              {comingFromCancel ?
                <button 
                  type="button" 
                  onClick={this.props.cancelInstead}
                  style={{
                    padding: '16px 20px',
                    borderRadius: '30px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: '#586B94',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    fontSize: '18px',
                    lineHeight: '1.3333333333333333em',
                    cursor: 'pointer',
                    marginRight: '16px'
                  }}
                >
                  Cancel SoothePass™
                </button>
                : 
                <button 
                  type="button" 
                  onClick={this.props.handleBack}
                  style={{
                    padding: '16px 20px',
                    borderRadius: '30px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: '#586B94',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    fontSize: '18px',
                    lineHeight: '1.3333333333333333em',
                    cursor: 'pointer',
                    marginRight: '16px'
                  }}
                >
                  Keep SoothePass™
                </button>
              }
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <button 
                type='button' 
                onClick={this.handlePauseMembership}
                disabled={isLoading}
                style={{
                  width: '343px',
                  padding: '16px 20px',
                  borderRadius: '30px',
                  border: 'none',
                  backgroundColor: isLoading ? '#CBCBCB' : '#F58266',
                  color: '#FFFFFF',
                  fontFamily: 'Poppins',
                  fontWeight: '500',
                  fontSize: '18px',
                  lineHeight: '1.3333333333333333em',
                  textAlign: 'center',
                  cursor: isLoading ? 'not-allowed' : 'pointer'
                }}
              >
                {isLoading ? "Pausing..." : "Pause membership"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  showRelevantState = () => {
    const state = get(this.props, 'client.soothe_pass.state', '');
    const { pause_end_date, pause_start_date } = this.state;
    const comingFromCancel = get(this.props, 'comingFromCancel', false);
    if (comingFromCancel) {
      return this.renderPauseForm();
    }
    if (pause_start_date && pause_end_date) {
      return this.renderPausedState();
    }
    switch (state) {
      case 'paused':
      case 'paused_pending':
        return this.renderPausedState();
      // return this.renderPausePendingState();
      case 'active':
        return this.renderPauseForm();
      default:
        return null;
    }
  };

  render() {
    const { showErrorModal, error, showSuccessModal } = this.state;
    return (
      <div>
        {this.showRelevantState()}
        <ErrorModal
          isOpen={showErrorModal}
          close={() => this.setState({ showErrorModal: false })}
        >
          {error}
        </ErrorModal>
        <SuccessModal
          isOpen={showSuccessModal}
          action={() => {
            this.setState({ showSuccessModal: false })
            this.props.handleBack(true);
          }}
          title="Membership Resumed Successfully!"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
});

const mapDispatchToProps = {
  loadClient,
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(PauseMembership)); 